import { AccountSettingsIcon } from './AccountSettingsIcon';

/**
 * author: Austin Andrews
 * id A975CEEA-FDFD-49A2-A618-E74A3FF87A63
 * name account-settings
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-settings.svg
 * tags
 * - Account / User 
 * - Settings 
 */
export const UserSettingsIcon = AccountSettingsIcon;
export default UserSettingsIcon